module.exports = __webpack_public_path__ + "media/images/client/favicons/android-chrome-152x152-894190c81a2c9e93f752054f1e0caa26.png";